import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, GuardsCheckStart } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { tap, filter, takeUntil } from 'rxjs/operators';
import { fromError } from '../reducers';
import { Error } from '../models';
import { errorSelectors } from '../selectors';
import { errorActions } from '../actions';

@Component({
  selector: 'app-error-container',
  templateUrl: './error-container.component.html',
  styleUrls: ['./error-container.component.scss']
})
export class ErrorContainerComponent implements OnInit, OnDestroy {
  errors$: Observable<Error[]>;
  hasError$: Observable<boolean>;
  private doNotClearOnDestory: boolean;
  private destroyed$ = new Subject();

  constructor(
    private store: Store<fromError.State>,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.errors$ = this.store.pipe(select(errorSelectors.getAllErrors));
    this.hasError$ = this.store.pipe(
      select(errorSelectors.getHasError),
      tap(hasError => {
        if (!hasError) {
          this.router.navigate(['/']);
        }
      })
    );
    this.route.data.pipe(takeUntil(this.destroyed$)).subscribe(data => {
      this.doNotClearOnDestory = data.doNotClearOnDestroy;
    });
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter(event => event instanceof GuardsCheckStart)
      )
      .subscribe(() => {
        if (!this.doNotClearOnDestory) {
          this.store.dispatch(new errorActions.Clear());
        }
      });
  }

  ngOnInit() {}

  dismissError(error: Error): void {
    this.store.dispatch(new errorActions.Remove(error));
  }

  ngOnDestroy() {
    if (!this.doNotClearOnDestory) {
      this.store.dispatch(new errorActions.Clear());
    }
    this.destroyed$.next(true);
  }
}
